import React from "react";
import styled, { css } from "styled-components";
import type { ChangeRate } from "types/BusinessDashboard";
import {
  TriangleBlueIcon,
  TriangleRedIcon,
} from "assets/icons/businessDashboard";

const IndicatorSpan = styled.span<{
  $color: string;
  $smallFont?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  letter-spacing: -0.2px;
  color: ${({ $color }) => $color};
  ${({ $smallFont }) =>
    $smallFont
      ? css`
          font-size: 0.75rem;
          font-weight: 500;
          line-height: 1rem;
        `
      : css`
          font-size: 1rem;
          font-weight: bold;
          line-height: 1.5rem;
        `}
`;

export const MembersChangeIndicator = ({
  changeRate,
  smallFont = false,
  showIcon = true,
}: {
  showIcon?: boolean;
  smallFont?: boolean;
  changeRate?: ChangeRate;
}) => {
  if (!changeRate) return null;

  if (changeRate.calculable === null) {
    return (
      <IndicatorSpan $color="#6b7280" $smallFont={smallFont}>
        0.0%
      </IndicatorSpan>
    );
  }

  if (!changeRate.calculable) {
    const isPositive = changeRate.positive === true;
    const Icon = isPositive ? TriangleBlueIcon : TriangleRedIcon;
    return (
      <IndicatorSpan
        $color={isPositive ? "#1F6AFF" : "#FD4235"}
        $smallFont={smallFont}
      >
        {showIcon && <Icon />} {isPositive ? "∞" : "-∞"}%
      </IndicatorSpan>
    );
  }

  const value = changeRate.value ?? 0;

  if (value > 0) {
    return (
      <IndicatorSpan $color="#1F6AFF" $smallFont={smallFont}>
        {showIcon && <TriangleBlueIcon />} {showIcon ? "" : "+"}
        {value.toFixed(1)}%
      </IndicatorSpan>
    );
  }
  if (value < 0) {
    return (
      <IndicatorSpan $color="#FD4235" $smallFont={smallFont}>
        {showIcon && <TriangleRedIcon />} {value.toFixed(1)}%
      </IndicatorSpan>
    );
  }
  return (
    <IndicatorSpan $color="#6b7280" $smallFont={smallFont}>
      {value.toFixed(1)}%
    </IndicatorSpan>
  );
};
